import React from "react";
import { Button, Modal } from "react-bootstrap";

type ConfirmationModalProps = {
  title: React.ReactNode;
  body: React.ReactNode;
  primaryText: React.ReactNode;
  secondaryText: React.ReactNode;
  show: boolean;
  handleClose: () => void;
  handlePrimary: () => void;
  handleSecondary: () => void;
  primaryVariant?: React.ComponentProps<typeof Button>["variant"];
  primaryDisabled?: boolean;
  secondaryDisabled?: boolean;
};

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  title,
  body,
  primaryText,
  secondaryText,
  show,
  handleClose,
  handlePrimary,
  handleSecondary,
  primaryVariant = "primary",
  primaryDisabled = false,
  secondaryDisabled = false,
}) => {
  return (
    <Modal centered show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Button
          onClick={handleSecondary}
          variant="secondary"
          size="sm"
          disabled={secondaryDisabled}
        >
          {secondaryText}
        </Button>
        <Button
          size="sm"
          variant={primaryVariant}
          onClick={handlePrimary}
          disabled={primaryDisabled}
        >
          {primaryText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
